export const ANALYTICS_USER_ACTIONS = {
  LOGIN_REGULAR_PROFILE: 'logins_regular_profile',
  LOGIN_FAMILY_PROFILE: 'logins_ikea_family',
  SIGNUP_DISPLAY_REGULAR_PROFILE: 'signup_begun_regular_profile',
  SIGNUP_DISPLAY_FAMILY_PROFILE: 'signup_begun_ikea_family',
  SIGNUP_COMPLETED_REGULAR_PROFILE: 'signup_completed_regular_profile',
  SIGNUP_COMPLETED_FAMILY_PROFILE: 'signup_complete_ikea_family',
  UPDATE_PROFILE: 'edit_profile',
  DELETE_PROFILE: 'delete_profile'
};

export const ANALYTICS_ACTIONS_LABELS = {
  SUCCESS: 'success',
  FAILED: 'failed',
  REGULAR_PROFILE_UPDATE: 'regular profile update',
  FAMILY_PROFILE_UPDATE: 'family profile update',
  REGULAR_PROFILE_UPGRADE: 'regular to family upgrade',
  REGULAR_PROFILE_USER_LOGIN_UPDATE: 'regular profile userlogin update',
  FAMILY_PROFILE_USER_LOGIN__UPDATE: 'family profile userlogin update',
  REGULAR_PROFILE_DELETE: 'regular profile delete',
  FAMILY_PROFILE_DELETE: 'family profile delete'
};

export const ANALYTICS_FIELD_MAPPING = {
  'family-allowSharingToSocialMedia': 'family_form',
  'regular-allowSharingToSocialMedia': 'regular_form'
};
